import React, { useState, useEffect, useContext } from "react";
import axios from "../axios/axios";
import Context from "../../Context/Context";
import { useNavigate } from "react-router-dom";

function MetasAvaliacao(props) {
  const { usuario } = useContext(Context);
  const [user, setUser] = useState(usuario);

  // Dados fictícios para teste
  // const [metas, setMetas] = useState({
  //   usuario: { nome: "João Silva" },
  //   entreguesAntesPrazo: 15,
  //   totalSolicitacoes: 20,
  //   ultimaAtualizacao: "2025-05-08T14:00:00Z",
  // });
  const nav = useNavigate();
  const [metas, setMetas] = useState(null);

  const fetchMetas = async () => {
    if (!user.role == "ComercialAvaliação") return;
    try {
      const { data } = await axios.get("/avaliacao/metas/" + usuario.id, {
        headers: { Authorization: usuario.token },
      });
      setMetas(data); // Supondo que há apenas um colaborador
    } catch (error) {
      console.error("Erro ao buscar metas:", error);
    }
  };

  useEffect(() => {
    if (usuario.role != "SupervisorNegocios") {
      if (!usuario.role.includes("Avaliação")) nav(-1);
    }
    if (props.metas) {
      setMetas(props.metas);
      setUser(props.user);
    } else {
      fetchMetas();
    }
  }, []);

  if (!metas) {
    return (
      <p className="text-center text-lg text-gray-600">Carregando dados...</p>
    );
  }

  // const calcularPorcentagem = () => {
  //   if (metas.totalSolicitacoes === 0) return 0;
  //   return ((metas.entreguesAntesPrazo / metas.totalSolicitacoes) * 100).toFixed(2);
  // };

  return (
    <div
      className={`flex justify-center items-center flex-col gap-10 mt-10 ${props?.metas?.length > 0 && "min-h-screen mt-0"}  min-w-[500px]`}
    >
      {!props?.user?.nome?.length > 0 && (
        <h2 className="text-black text-3xl font-semibold">Metas</h2>
      )}

      <div className="w-full max-w-lg bg-white border border-gray-200 rounded-3xl shadow-2xl dark:bg-gray-800 dark:border-gray-700">
        <div className="flex justify-end px-4 pt-4"></div>
        <div className="flex flex-col items-center pb-10">
          <img
            className="w-32 h-32 mb-4 rounded-full shadow-lg border-4 border-slate-500 dark:border-blue-700"
            src={user.usuario_foto}
            alt="Imagem do Colaborador"
          />
          <h5 className="mb-2 text-2xl font-bold text-gray-900 dark:text-white">
            {user.nome}
          </h5>
          <span className="flex items-center text-lg text-gray-600 dark:text-gray-400">
            <svg
              className="w-5 h-5 mr-2 text-black"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 16l-4-4m0 0l4-4m-4 4h16"
              />
            </svg>
            Total de Solicitações: {metas.total}
          </span>
          <span className="flex items-center text-lg text-gray-600 dark:text-gray-400">
            <svg
              className="w-5 h-5 mr-2 text-green-500"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
            Entregues Antes do Prazo: {metas.entregues}
          </span>
          <span className="text-lg font-semibold text-slate-800 dark:text-blue-400">
            Porcentagem: {metas.porcentagem?.toString()?.slice(0, 4)}%
          </span>
          <div className="w-full bg-gray-200 rounded-full h-4 dark:bg-gray-700 mt-4 max-w-[40%]">
            <div
              className="bg-slate-800 h-4 rounded-full transition-all duration-300"
              style={{ width: `${metas.porcentagem}%` }}
            ></div>
          </div>
          <span className="text-sm text-gray-500 dark:text-gray-400 mt-2">
            Última atualização:{" "}
            {new Date()
              .toISOString()
              .split("T")[0]
              .split("-")
              .reverse()
              .join("/")}
          </span>
        </div>
      </div>
    </div>
  );
}

export default MetasAvaliacao;
